import React, { useContext, useEffect, useState } from 'react';
import storage from 'local-storage-fallback';
import styled from 'styled-components';
import { Header, Sidebar } from '../_components';
import { AuthContext, ContentContext } from '../_context';
import { breakpoints } from '../_helpers/breakpoints';
import RegisterPhone from '~/_components/Layout/RegisterPhone';
import CountdownVideoLanding from '~/_components/Layout/CountdownVideoLanding';
import useMediaQuery from "../_hooks/useMediaQuery";
import { useHistory } from 'react-router';

import { FaWhatsapp } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";


//import Evaluation from '~/_components/Evaluation';


const WrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;

  min-height: 100%;
  
  background-color: ${props => props.background.type === 'color' ? props.background.hexa : 'transparent'}!important;
  
  background-size: ${props => props.background.type === 'image' ? props.background.size : 'unset'};
  background-repeat: ${props => props.background.type === 'image' ? props.background.repeat : 'unset'};
  background-image: ${props => props.background.type === 'image' ? "url('"+props.background.url+"')" : 'unset'};
  background-attachment: ${props => props.background.type === 'image' ? props.background.attachment : 'unset'};
  background-position-x: ${props => props.background.type === 'image' ? props?.background?.position_x : 'unset'};

  background: ${props => props.background.type === 'gradient' && props.background.gradient ? props.background.gradient : ''}!important;
  
  .bt_whatsapp{
    display: flex;
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
    font-size: 50px;
    color: #25d366;
    cursor: pointer;
    :hover{
      color: #128c7e;
    }
  }

  >.inner{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;
  }
  /*
  &.incentivo-autitos{
    .sideright{
      width: 100%!important;
      margin-left: 112px!important;
    }
    .box_content{
      margin-top: 79px!important;
    }
  }
  */

  @media ${breakpoints.sm} {
    .bt_whatsapp{
      display: none;
    }
  }
`
const WrapperBaristas = styled.div`
  /* display: flex;
  flex-direction: column;
  justify-content: flex-start!important;
  align-items: flex-start!important;
  width: 100%;
  background-color: #353535; */

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  overflow: hidden;
  min-height: 100%;
  
  background-color: #3c3c3b!important;
  background-repeat: repeat;
  background-image: url("/images/baristas_backdots_2026.svg");
  background-position-x: center;
  /* background-size: cover; */
  
  /*
  background-size: ${props => props.background.type === 'image' ? props.background.size : 'unset'};
  background-repeat: ${props => props.background.type === 'image' ? props.background.repeat : 'unset'};
  background-image: ${props => props.background.type === 'image' ? "url('"+props.background.url+"')" : 'unset'};
  background-attachment: ${props => props.background.type === 'image' ? props.background.attachment : 'unset'};
  */
  >.inner{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;
  }

  
`

const WrapperIncentivo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  overflow: hidden;
  min-height: 100%;
  
  background-color: ${props => props.background.type === 'color' ? props.background.hexa : 'transparent'}!important;
  
  background-size: ${props => props.background.type === 'image' ? props.background.size : 'unset'};
  background-repeat: ${props => props.background.type === 'image' ? props.background.repeat : 'unset'};
  background-image: ${props => props.background.type === 'image' ? "url('"+props.background.url+"')" : 'unset'};
  background-attachment: ${props => props.background.type === 'image' ? props.background.attachment : 'unset'};
  background-position-x: ${props => props.background.type === 'image' ? props?.background?.position_x : 'unset'};

  background: ${props => props.background.type === 'gradient' && props.background.gradient ? props.background.gradient : ''}!important;

  >.inner{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;
  }
`

const WrapperFullWidth = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  overflow: hidden;
  min-height: 100%;
  
  background-color: ${props => props.background.type === 'color' ? props.background.hexa : 'transparent'}!important;
  
  background-size: ${props => props.background.type === 'image' ? props.background.size : 'unset'};
  background-repeat: ${props => props.background.type === 'image' ? props.background.repeat : 'unset'};
  background-image: ${props => props.background.type === 'image' ? "url('"+props.background.url+"')" : 'unset'};
  background-attachment: ${props => props.background.type === 'image' ? props.background.attachment : 'unset'};
  background-position-x: ${props => props.background.type === 'image' ? props?.background?.position_x : 'unset'};

  background: ${props => props.background.type === 'gradient' && props.background.gradient ? props.background.gradient : ''}!important;

  
  >.inner{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;
  }
  .sideright{
    width: 100%!important;
    margin-left: 0!important;
  }
  
`

const WrapperLogin = styled.div`
  display: flex;
  width: 100%;
  height: 100%;

`
const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;//768px;//calc(100% - 30px);
  //padding-top: 2vw;
  //padding-bottom: 10vw;

  position: relative;
  margin-top: 90px;
  z-index: 6;

  &.removelayout{
    margin-top: 0;
  }

  //background-color: gray;
  @media ${breakpoints.xs} {
    //padding-top: 10px;
    //padding-bottom: 50px;
    //width: 576px;
  }
  @media ${breakpoints.sm} {
    //width: 768px;
  }
  @media ${breakpoints.md} {
    //width: 951px;
  }
  @media ${breakpoints.lg} {
    //width: 1160px;
  }
`

const Layout = ({children}) => {

  //const { history, location } = useHistory();
  const history = useHistory();

  const isSm = useMediaQuery('(min-width: 768px)');
  //showMoreStats, setShowMoreStats,

  const { isAuth } = useContext(AuthContext);
  const { userData,
          setShowMoreStats,
          colorPallete,
          setColorPallete,
          setVideoViewed,
          getInternalCourses,
          evaluationData,
          setEvaluationData } = useContext(ContentContext);

  const [ background, setBackground ] = useState({default: true, type: 'color', hexa: '#FFFFFF'});
  const [ sectionName, setSectionName ] = useState(null);

  const handleOpenModalContactoWhatsapp = () => {
    window.open("https://wa.me/5491134467911", '_blank').focus();
  }

          
  useEffect(() => {
    setShowMoreStats(isSm);
    return () => {}
  }, [isSm])

  useEffect(() => {

    const section_name = history.location.pathname.split("/")[1];
    setSectionName(section_name);
    switch (section_name) {
      case 'trivia':

        /*
        setBackground({default: true, type: 'color', hexa: '#FFFFFF'});
        setColorPallete({type: 'default', primary: '#000000', secondary: '#FFFFFF', terciary: '#F5F6FA', border: '204, 204, 204', background: '#FFFFFF', altbackground: 'rgba(0, 0, 0, 0.5)'});
        */

        break;
      case 'shellbox':

        /*
        setBackground({default: false,
                       type: 'image',
                       url: '/images/background_latambox1.svg',
                       repeat: 'repeat-y',
                       attachment: 'fixed',
                       size: 'cover'});
                       
        setColorPallete({type: 'shellbox', primary: '#000000', secondary: '#FFFFFF', terciary: '#F5F6FA', border: '255, 255, 255', background: 'rgba(255, 255, 255, 0.30)', altbackground: 'rgba(255, 255, 255, 1)'});
        */

        break;
      case 'qatar2022':

        /*
        setBackground({default: false,
                       type: 'image',
                       url: '/images/background_qatar2022_1.svg',
                       repeat: 'repeat-y',
                       attachment: 'fixed',
                       size: 'cover'});

        setColorPallete({type: 'shellbox', primary: '#FFFFFF', secondary: '#FFFFFF', terciary: '#F5F6FA', border: '255, 255, 255', background: 'rgba(255, 255, 255, 0.30)', altbackground: 'rgba(255, 255, 255, 1)'});
        */

        break;
      case 'challengebox':

        /*
        setBackground({default: false,
                       type: 'image',
                       url: '/images/fondo-amarillo1.jpg',
                       //url: '/images/background_challengebox.jpg',
                       repeat: 'repeat',
                       attachment: 'fixed',
                       size: 'contain'});

        setColorPallete({type: 'shellbox', primary: '#000000', secondary: '#FFFFFF', terciary: '#F5F6FA', border: '255, 255, 255', background: 'rgba(255, 255, 255, 0.30)', altbackground: 'rgba(255, 255, 255, 1)'});
        */

        break;
      case 'semana-de-la-seguridad':

        // setBackground({default: false,
        //                type: 'image',
        //                url: '/images/back_diaseguridad5.jpg',
        //                //url: '/images/background_challengebox.jpg',
        //                repeat: 'repeat',
        //                attachment: 'fixed',
        //                size: 'cover'});

        setBackground({default: true, type: 'color', hexa: '#FFC600'});
        setColorPallete({type: 'shellbox', primary: '#FFD200', secondary: '#FFFFFF', terciary: '#F5F6FA', border: '255, 210, 0', background: 'rgba(0, 0, 0, 0.5)', altbackground: 'rgba(0, 0, 0, 0.5)'});

        break;
      case 'incentivo-tiendas':

        setBackground({default: false,
                       type: 'image',
                       url: '/images/back_incentivotiendas.jpg',
                       //url: '/images/background_challengebox.jpg',
                       repeat: 'repeat',
                       attachment: 'fixed',
                       size: 'cover'});

        //setBackground({default: true, type: 'color', hexa: '#FFC600'});
        setColorPallete({type: 'shellbox', primary: '#FFD200', secondary: '#FFFFFF', terciary: '#F5F6FA', border: '255, 210, 0', background: 'rgba(0, 0, 0, 0.5)', altbackground: 'rgba(0, 0, 0, 0.5)'});

        break;
      case 'promo-jeep':

        setBackground({default: false,
                       type: 'image',
                       url: '/images/back_promojeep.jpg',
                       //url: '/images/background_challengebox.jpg',
                       repeat: 'repeat',
                       attachment: 'fixed',
                       size: 'cover'});

        //setBackground({default: true, type: 'color', hexa: '#FFC600'});
        setColorPallete({type: 'shellbox', primary: '#FFD200', secondary: '#FFFFFF', terciary: '#F5F6FA', border: '255, 210, 0', background: 'rgba(0, 0, 0, 0.5)', altbackground: 'rgba(0, 0, 0, 0.5)'});

        break;
      case 'incentivo-autitos':

        setBackground({default: false,
                       type: 'image',
                       url: '/images/back_incentivoautitos4.jpg',
                       //url: '/images/background_challengebox.jpg',
                       repeat: 'repeat',
                       attachment: 'local',
                       position_x: 'center',
                       size: 'cover'});

        //setBackground({default: true, type: 'color', hexa: '#FFC600'});
        setColorPallete({type: 'shellbox', primary: '#FFD200', secondary: '#FFFFFF', terciary: '#F5F6FA', border: '255, 210, 0', background: 'rgba(0, 0, 0, 0.5)', altbackground: 'rgba(0, 0, 0, 0.5)'});

        break;
      case 'incentivo-autitos-starwars':

        setBackground({default: false,
                       type: 'image',
                       url: '/images/back_incentivoautitosstarwars.jpg',
                       //url: '/images/background_challengebox.jpg',
                       repeat: 'repeat',
                       attachment: 'local',
                       position_x: 'center',
                       size: 'cover'});

        //setBackground({default: true, type: 'color', hexa: '#FFC600'});
        setColorPallete({type: 'shellbox', primary: '#FFD200', secondary: '#FFFFFF', terciary: '#F5F6FA', border: '255, 210, 0', background: 'rgba(0, 0, 0, 0.5)', altbackground: 'rgba(0, 0, 0, 0.5)'});

        break;
      case 'incentivo-mundial-2026':

        // setBackground({default: false,
        //                type: 'image',
        //                url: '/images/back_incentivoautitosstarwars.jpg',
        //                //url: '/images/background_challengebox.jpg',
        //                repeat: 'repeat',
        //                attachment: 'local',
        //                position_x: 'center',
        //                size: 'cover'});

        // setBackground({default: true, type: 'color', hexa: '#FFC600'});
        setBackground({default: true, type: 'gradient', hexa: '#FFC600', gradient: 'linear-gradient(143deg,rgba(246, 191, 0, 1) 0%, rgba(246, 191, 0, 1) 50%, rgba(254, 224, 111, 1) 100%)'});
        setColorPallete({type: 'shellbox', primary: '#FFD200', secondary: '#FFFFFF', terciary: '#F5F6FA', border: '255, 210, 0', background: 'rgba(0, 0, 0, 0.5)', altbackground: 'rgba(0, 0, 0, 0.5)'});

        break;
      case 'lista-mundial':

        // setBackground({default: false,
        //                type: 'image',
        //                url: '/images/back_incentivoautitosstarwars.jpg',
        //                //url: '/images/background_challengebox.jpg',
        //                repeat: 'repeat',
        //                attachment: 'local',
        //                position_x: 'center',
        //                size: 'cover'});

        // setBackground({default: true, type: 'color', hexa: '#FFC600'});
        setBackground({default: true, type: 'gradient', hexa: '#FFC600', gradient: 'linear-gradient(0deg,rgba(255, 255, 255, 1) 65%, rgba(152, 206, 241, 1) 90%)'});
        setColorPallete({type: 'shellbox', primary: '#FFD200', secondary: '#FFFFFF', terciary: '#F5F6FA', border: '255, 210, 0', background: 'rgba(0, 0, 0, 0.5)', altbackground: 'rgba(0, 0, 0, 0.5)'});

        break;
      case 'promo-cocacola':

        // setBackground({default: false,
        //                type: 'image',
        //                url: '/images/back_incentivoautitosstarwars.jpg',
        //                //url: '/images/background_challengebox.jpg',
        //                repeat: 'repeat',
        //                attachment: 'local',
        //                position_x: 'center',
        //                size: 'cover'});

        setBackground({default: true, type: 'color', hexa: '#E30613'});
        //setBackground({default: true, type: 'gradient', hexa: '#FFC600', gradient: 'linear-gradient(143deg,rgba(246, 191, 0, 1) 0%, rgba(246, 191, 0, 1) 50%, rgba(254, 224, 111, 1) 100%)'});
        setColorPallete({type: 'shellbox', primary: '#FFD200', secondary: '#FFFFFF', terciary: '#F5F6FA', border: '255, 210, 0', background: 'rgba(0, 0, 0, 0.5)', altbackground: 'rgba(0, 0, 0, 0.5)'});

        break;
      case 'promo-toystory':

        // setBackground({default: false,
        //                type: 'image',
        //                url: '/images/promo_toystory_background.jpg',
        //                //url: '/images/background_challengebox.jpg',
        //                repeat: 'repeat',
        //                attachment: 'local',
        //                position_x: 'center',
        //                size: 'auto'});

        setBackground({default: true, type: 'color', hexa: '#05baee'});
        //setBackground({default: true, type: 'gradient', hexa: '#FFC600', gradient: 'linear-gradient(143deg,rgba(246, 191, 0, 1) 0%, rgba(246, 191, 0, 1) 50%, rgba(254, 224, 111, 1) 100%)'});
        setColorPallete({type: 'shellbox', primary: '#FFD200', secondary: '#FFFFFF', terciary: '#F5F6FA', border: '255, 210, 0', background: 'rgba(0, 0, 0, 0.5)', altbackground: 'rgba(0, 0, 0, 0.5)'});

        break;
      case 'competencia-shellbox':

        // setBackground({default: false,
        //                type: 'image',
        //                url: '/images/promo_toystory_background.jpg',
        //                //url: '/images/background_challengebox.jpg',
        //                repeat: 'repeat',
        //                attachment: 'local',
        //                position_x: 'center',
        //                size: 'auto'});

        setBackground({default: true, type: 'color', hexa: '#05baee'});
        //setBackground({default: true, type: 'gradient', hexa: '#FFC600', gradient: 'linear-gradient(143deg,rgba(246, 191, 0, 1) 0%, rgba(246, 191, 0, 1) 50%, rgba(254, 224, 111, 1) 100%)'});
        setColorPallete({type: 'shellbox', primary: '#FFD200', secondary: '#FFFFFF', terciary: '#F5F6FA', border: '255, 210, 0', background: 'rgba(0, 0, 0, 0.5)', altbackground: 'rgba(0, 0, 0, 0.5)'});

        break;
      case 'incentivo-autitos-ferrari':

        // setBackground({default: false,
        //                type: 'image',
        //                url: '/images/back_incentivoautitos4.jpg',
        //                //url: '/images/background_challengebox.jpg',
        //                repeat: 'repeat',
        //                attachment: 'local',
        //                position_x: 'center',
        //                size: 'cover'});

        setBackground({default: true, type: 'gradient', hexa: '#830E00', gradient: 'linear-gradient(143deg,rgba(254, 94, 82, 1) 0%, rgba(186, 24, 7, 1) 50%, rgba(128, 13, 0, 1) 100%)'});
        setColorPallete({type: 'shellbox', primary: '#FFD200', secondary: '#FFFFFF', terciary: '#F5F6FA', border: '255, 210, 0', background: 'rgba(0, 0, 0, 0.5)', altbackground: 'rgba(0, 0, 0, 0.5)'});

        break;
      case 'mas-power-que-nunca':

        // setBackground({default: false,
        //                type: 'image',
        //                url: '/images/back_incentivoautitos4.jpg',
        //                //url: '/images/background_challengebox.jpg',
        //                repeat: 'repeat',
        //                attachment: 'local',
        //                position_x: 'center',
        //                size: 'cover'});

        setBackground({default: true, type: 'color', hexa: '#000000'});
        setColorPallete({type: 'shellbox', primary: '#FFD200', secondary: '#FFFFFF', terciary: '#F5F6FA', border: '255, 210, 0', background: 'rgba(0, 0, 0, 0.5)', altbackground: 'rgba(0, 0, 0, 0.5)'});

        break;
      default:

        /*
        if(section_name !== 'shellbox'){
          if(!background.default){
            setBackground({default: true, type: 'color', hexa: '#FFFFFF'});
          }
        }
        */

        
        setBackground({default: true, type: 'color', hexa: '#FFFFFF'});
        setColorPallete({type: 'default', primary: '#000000', secondary: '#FFFFFF', terciary: '#F5F6FA', border: '204, 204, 204', background: '#FFFFFF', altbackground: 'rgba(204, 204, 204, 0.4)'});
        

        break;
    }

    if(isSm){
      setShowMoreStats(true);
    }else{
      setShowMoreStats(false);
    }
    return () => {}
  }, [history.location])

  /*
  let isMobileApp = false;
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.get('utm_source') === 'mobile_app') {
    isMobileApp = true;
  }
  */

  useEffect(() => {
    //console.log("history.location.pathname", history.location.pathname == "/baristas")
    return () => {

    }
  }, [])

  //if (user.isAuth === false || Object.keys(protagonista).length === 0 || Object.keys(notificaciones).length === 0) {
  if (isAuth === false) {
    return <WrapperLogin>{children}</WrapperLogin>;
  }

  if(history.location.pathname == "/baristas"){
    return (
      <WrapperBaristas className='wrapper_baristas' breakpoints={breakpoints} background={background}>
        <div className='inner'>{children}</div>
      </WrapperBaristas>
    )
  }

  if(history.location.pathname == "/incentivo-autitos-ferrari"){
    return (
      <WrapperIncentivo className='wrapper_incentivo' breakpoints={breakpoints} background={background}>
        <div className='inner'>{children}</div>
      </WrapperIncentivo>
    )
  }

  if(history.location.pathname == "/incentivo-autitos-starwars"){
    return (
      <WrapperIncentivo className='wrapper_incentivo' breakpoints={breakpoints} background={background}>
        <div className='inner'>{children}</div>
      </WrapperIncentivo>
    )
  }

  if(history.location.pathname == "/lista-mundial"){
    return (
      <WrapperFullWidth className='' breakpoints={breakpoints} background={background}>
        <div className='inner'>{children}</div>
      </WrapperFullWidth>
    )
  }

  if(history.location.pathname == "/promo-cocacola"){
    return (
      <WrapperFullWidth className='' breakpoints={breakpoints} background={background}>
        <div className='inner'>{children}</div>
      </WrapperFullWidth>
    )
  }

  if(history.location.pathname == "/promo-toystory"){
    return (
      <WrapperFullWidth className='' breakpoints={breakpoints} background={background}>
        <div className='inner'>{children}</div>
      </WrapperFullWidth>
    )
  }

  if(history.location.pathname == "/competencia-shellbox"){
    return (
      <WrapperFullWidth className='' breakpoints={breakpoints} background={background}>
        <div className='inner'>{children}</div>
      </WrapperFullWidth>
    )
  }

  let splited_history = (history?.location?.pathname?.split('/'))[1];
  //console.log("splited_history: ", splited_history)
  if(splited_history == "incentivo-mundial-2026"){
    return (
      <WrapperIncentivo className='wrapper_incentivo' breakpoints={breakpoints} background={background}>
        <div className='inner'>{children}</div>
      </WrapperIncentivo>
    )
  }

  return (
    <WrapperStyled 
      breakpoints={breakpoints} 
      background={background}
      className={`${history.location.pathname.split("/")[1]}`}
    >
      {history.location.pathname.split("/")[1] !== 'promo-jeep' && <Header />}
      <div className='inner'>
        {history.location.pathname.split("/")[1] !== 'promo-jeep' && <Sidebar />}
        <Content className={`box_content${history.location.pathname.split("/")[1] === 'promo-jeep' ? ' removelayout' : ''}`}>
          {children}
        </Content>

        <div className="bt_whatsapp" onClick={() => handleOpenModalContactoWhatsapp()}>

          <IoLogoWhatsapp />

        </div>

      </div>
      <RegisterPhone />
    </WrapperStyled>
  )

}

export default Layout;
